import { supabase } from '../supabaseClient';

/* Accès aux données « jira_consumption ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchJiraConsumption() {
  return supabase.from('jira_consumption').select('*').order('kind').order('jira_key');
}

export function upsertJiraConsumption(rows) {
  return supabase.from('jira_consumption').upsert(rows, { onConflict: 'kind,jira_key' });
}
